import { useNavigate } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { Container } from '@hivebrite/design-system/Container';

import EmptyStateMentoring from 'hb-react/backoffice/apps/Mentoring/components/EmptyStateMentoring';
import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

export const NotAuthorized = ({ title, description }) => {
  const navigate = useNavigate();

  return (
    <Container>
      <Grid width="100%">
        <Row>
          <Col
            offset={{
              _: 0,
              l: 2 / 12,
              xl: 3 / 12,
            }}
            width={{ _: 1, l: 8 / 12, xl: 6 / 12 }}
          >
            <Box display="block" mt={6}>
              <Card>
                <EmptyStateMentoring
                  title={title}
                  description={description}
                  buttonProps={{
                    onClick: () => navigate(`/my-mentoring`),
                    children: s__('Mentoring|Go back to My mentoring programs'),
                  }}
                />
              </Card>
            </Box>
          </Col>
        </Row>
      </Grid>
    </Container>
  );
};
